import { Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react';

export default function ButtonShowModalStatus(props) {
  const { info } = props;

  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {}, []);

  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOK = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Button onClick={showModal}>
        <i className="far fa-eye"></i>
      </Button>
      <Modal
        title={`Trạng thái của booking ${info.book_code} `}
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={handleOK}
        width={800}
      >
        {!info.transferStatus?.length > 0 ? (
          <p>Yêu cầu đang chờ được phê duyệt</p>
        ) : (
          info.transferStatus.map((ts) => {
            return (
              <p>
                {`${ts.creator} cập nhập lên trạng thái ${
                  ts.new_status
                } lúc ${new Date(ts.updated_at)} `}
              </p>
            );
          })
        )}
      </Modal>
    </>
  );
}
